"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NocodeWizardFormBox = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const join_1 = tslib_1.__importDefault(require("../../../../components/utils/join"));
const NocodeWizardFormBox = (props) => (React.createElement(rebass_1.Box, Object.assign({}, props, { padding: 2, mb: 2, className: (0, join_1.default)('ab-NocodeWizardFormBox', props.className) })));
exports.NocodeWizardFormBox = NocodeWizardFormBox;
